export const HEADER_HEIGHT_XS_SM = 124;
export const HEADER_HEIGHT_MD_LG_XL = 139;

export const LEGACY_HEADER_HEIGHT = 100;
